import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/store.hooks";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import buy_bonus from "../../../assets/filters/buy_bonus.png";
import cards from "../../../assets/filters/card.png";
import crash from "../../../assets/filters/crash.png";
import jackpots from "../../../assets/filters/jackpots.png";
import live from "../../../assets/filters/live.png";
import megaways from "../../../assets/filters/megaways.png";
import new_image from "../../../assets/filters/new.png";
import popular from "../../../assets/filters/popular.png";
import recommended from "../../../assets/filters/recommended.png";
import roulette from "../../../assets/filters/roulette.png";
import slots from "../../../assets/filters/money_bag.png";
import award from "../../../assets/icons/menu/award.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Swiper as SwiperType } from "swiper/types";
import "swiper/css";
import "swiper/css/navigation";
import arrow from "../../../assets/icons/arrow-down.svg";
import { useMediaQuery } from "react-responsive";
import "./CategoriesSection.css";
const filters = [
  {
    name: "popular",
    image: popular,
    path: "/lobby/slots?popular=true",
    key: "Slots_1_popular",
  },
  {
    name: "new",
    image: new_image,
    path: "/lobby/slots?new=true",
    key: "Slots_new_1",
  },
  {
    name: "recommended",
    image: recommended,
    path: "/lobby/slots?recommended=true",
    key: "Slots_1_recommended",
  },
  {
    name: "slots",
    image: slots,
    path: "/lobby/slots",
    key: "all_Slots_1",
  },
  {
    name: "buy_fs",
    image: buy_bonus,
    path: "/lobby/slots?buy_fs=true",
    key: "BonusBuy_1",
  },
  {
    name: "jackpots",
    image: jackpots,
    path: "/lobby/slots?category=jackpots",
    key: "Jackpot_1",
  },
  {
    name: "live",
    image: live,
    path: "/lobby/live",
    key: "LiveGames_1",
  },
  {
    name: "crash_games",
    image: crash,
    path: "/lobby/crash",
    key: "InstantWin_1",
  },
  {
    name: "roulette",
    image: roulette,
    path: "/lobby/live?category=roulette",
    key: "Roulette_1",
  },
  {
    name: "card_games",
    image: cards,
    path: "/lobby/live?category=card_games",
    key: "CardGames_1",
  },
  {
    name: "mega_ways",
    image: megaways,
    path: "/lobby/slots?category=megaways",
    key: "MegaWays_1",
  },
];
export const CategoriesSection = () => {
  const { t } = useTranslation();
  const navigator = useNavigate();
  const applyFilter = (path: string) => {
    navigator(path);
  };
  const [isLastSlide, setIsLastSlide] = useState(false);

  const handleSlideChange = (swiper: SwiperType) => {
    if (swiper.isEnd) {
      setIsLastSlide(true);
    } else {
      setIsLastSlide(false);
    }
  };
  const isMobile = useMediaQuery({ maxWidth: 599.98 });
  return (
    <Box className="slots-section">
      <Swiper
        modules={[Navigation]}
        onSlideChange={handleSlideChange}
        spaceBetween={10}
        slidesPerView={"auto"}
        navigation={{
          disabledClass: "slots-section-disabled",
          prevEl: ".slots-section-prev",
          nextEl: ".slots-section-next",
        }}
        className="slots-section__swiper"
      >
        {filters.map((filter) => {
          return (
            <SwiperSlide
              className="slide__categories"
              key={`slots_${filter.name}`}
            >
              <Box
                className="slots-categories"
                onClick={() => {
                  applyFilter(filter.path);
                }}
              >
                <Box className="slots-categories__content">
                  <img src={filter.image} alt={filter.name} />
                  {t(`slots.lobby.heading.${filter.name}`)}
                  <span>
                    {t("slots.lobby.category.games")}
                    <CategoriesSectionCount stateKey={filter.key} />
                  </span>
                </Box>
              </Box>
            </SwiperSlide>
          );
        })}
        <Box className="slots-section-prev">
          <img src={arrow} alt="Prev" />
        </Box>
        <Box className="slots-section-next">
          <img src={arrow} alt="Next" />
        </Box>
        <Box className="slots-section__heading">
          <img src={award} alt={"Categories"} />
          {t(`main.menuItems.categories`)}
        </Box>
        {!isLastSlide && !isMobile && (
          <Box className="slots-section__end"></Box>
        )}
      </Swiper>
    </Box>
  );
};

export const CategoriesSectionCount = ({ stateKey }: { stateKey: string }) => {
  const count = useAppSelector(
    (state) => state.slots.savedGames[stateKey]?.count
  );
  return <>{count ? count?.toString() : ""}</>;
};
